'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SinglePage = undefined;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _reactDocumentTitle = require('react-document-title');

var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var SinglePage = exports.SinglePage = function SinglePage(_ref) {
    var page = _ref.page,
        appTitle = _ref.appTitle;
    return React.createElement("div", null, React.createElement(_reactDocumentTitle2.default, { title: page.title + ' - ' + appTitle }), React.createElement(page.component, null));
};
//# sourceMappingURL=single-page.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./~/documittu-template-default/dist/components/pages/single-page.js
 ** module id = 486
 ** module chunks = 0
 **/